<template>
    <div    
                    v-bind:style="styleObject" 
                    v-show="!block.Active && block.Show" 
                    v-on:mouseleave="mouseLeaveTooltip()" 
                    v-on:mouseover="mouseOverTooltip()">

            <div style="padding: 10px">
                {{message}}
            </div>
            
            <div class="col-md-offset-2 col-md-7 text-center">
                
                <button  v-on:click="goToContact(Contact)"
                            class="btn btn-sm btn-contact" style="font-weight: BOLD" 
                            v-bind:style="contactStyle" 
                            @click="goToContact" >
                            CONTACT
                </button>
            </div>

        </div>
</template>
<script>

import * as UI from '../services/mainUI';

export default {
    props:['block'],
    data: function(){
           return {
               message: "Your current subscription does not include this feature. Contact SMI now to upgrade and gain access.",
               styleObject: UI.styleObject,
               contactStyle: UI.contactStyle,
           };
       },
    methods: {
        mouseLeaveTooltip: function(){
            this.block.Show = false;
        },
        
        mouseOverTooltip: function(){
            this.block.Show = true;
        },
        
        goToContact: function(){
            UI.goToContact(this.block.contact)
        },
    },
}
</script>